{
  "jira-nin-list-merge-modal-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.copyListSettingsDescription": [
    {
      "type": 0,
      "value": "Want us to apply your current filter and group settings to this new List view?"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.copyListSettingsNo": [
    {
      "type": 0,
      "value": "No"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.copyListSettingsYes": [
    {
      "type": 0,
      "value": "Yes"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.description": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. Core features such as sorting and conditional formatting will still be available"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.exploreListViewButtonLabel": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-modal-onboarding.learnMoreLink": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience."
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.filter": [
    {
      "type": 0,
      "value": "One place to search work and filter results to find what you need."
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.more-actions": [
    {
      "type": 0,
      "value": "Dive deeper - view work items as a chart, use format rules to highlight key work, and more."
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more": [
    {
      "type": 0,
      "value": "Tell me more"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ]
}